import { render, staticRenderFns } from "./EdudashGraph.vue?vue&type=template&id=5830acc6&"
import script from "./EdudashGraph.vue?vue&type=script&lang=js&"
export * from "./EdudashGraph.vue?vue&type=script&lang=js&"
import style0 from "./EdudashGraph.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports